// Runtime controls for the Contentsquare tag (UXA c1cd8d5cb5d96).
//
// The tag itself is loaded from public/index.html and is gated to the
// production hostname. Everything here narrows *what* it records once the app
// knows who the user is and which module they are in. Every helper no-ops when
// the tag never loaded (non-production host, ad blocker, network failure) —
// same defensive contract as the other helpers in this folder.
//
// Commands go onto the window._uxa queue. The tag drains commands that were
// queued before it finished loading, so these are safe to call at any point,
// including before the async script has arrived.

import { matchRoutes } from "react-router-dom";
import { protectedRoutes } from "configs/RoutesConfig";

const INTERNAL_EMAIL_SUFFIX = "@teamsunday.com";

// Wardrobe route patterns, read from RoutesConfig's `meta.isWardrobe` flag
// rather than duplicated here, so new wardrobe pages are excluded
// automatically. The module has no URL prefix of its own (APP_PREFIX_PATH is
// ""), so the flag is the only reliable way to identify it.
const wardrobeRoutes = protectedRoutes
  .filter((route) => route.meta?.isWardrobe)
  .map((route) => ({ path: route.path }));

export function isWardrobeRoute(pathname) {
  return !!matchRoutes(wardrobeRoutes, { pathname });
}

// Sunday staff aren't customers — their sessions are noise in the replay data.
// Mirrors the domain test already used in components/tickets/TicketDetailDrawer.js.
export function isInternalEmail(email) {
  if (typeof email !== "string") return false;
  return email.toLowerCase().trim().endsWith(INTERNAL_EMAIL_SUFFIX);
}

function csPush(...command) {
  if (typeof window === "undefined") return;
  if (!Array.isArray(window._uxa)) return;
  window._uxa.push(command);
}

// Permanent, browser-wide opt-out. Contentsquare persists this in its own
// _cs_optout cookie (~395 days), so subsequent visits are suppressed before
// the tag starts recording rather than after — which is what makes the
// internal-user exclusion reliable despite the email only being known one
// /me round-trip after boot.
export function csOptOut() {
  csPush("optout");
}

export function csStopCollection() {
  csPush("data-collection:stop");
}

export function csStartCollection() {
  csPush("startDataCollection");
}
